import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

window.Pusher = Pusher;

const APP_KEY = process.env.REACT_APP_PUSHER_APP_KEY;
const APP_CLUSTER = process.env.REACT_APP_PUSHER_APP_CLUSTER;

const echo = new Echo({
    broadcaster: 'pusher',
    key: APP_KEY,
    cluster: APP_CLUSTER,
    forceTLS: true,
});

export default echo;
